import { makeAutoObservable } from "mobx";
import { SignatureAudit, SignatureAuditRequest } from "../../models/SignatureAudit";
import { signatureAuditApi } from "../../apis/SignatureAudit";

export class SignatureAuditPageModel {
    candidates: SignatureAudit[] = [];
    processed: SignatureAudit[] = [];
    selectedAudit: SignatureAudit | null = null;
    showRefuseDialog: boolean = false;
    showConfirmDialog: boolean = false;
    refuseReason: string = "";
    loading: boolean = false;

    constructor() {
        makeAutoObservable(this);
    }

    async loadCandidates() {
        this.loading = true;
        try {
            this.candidates = await signatureAuditApi.getAllCandidates();
        } finally {
            this.loading = false;
        }
    }

    async loadProcessed() {
        this.loading = true;
        try {
            this.processed = await signatureAuditApi.getAllProcessed();
        } finally {
            this.loading = false;
        }
    }

    setSelectedAudit(audit: SignatureAudit | null) {
        this.selectedAudit = audit;
    }

    setShowRefuseDialog(show: boolean) {
        this.showRefuseDialog = show;
        if (!show) {
            this.refuseReason = "";
        }
    }

    setShowConfirmDialog(show: boolean) {
        this.showConfirmDialog = show;
    }

    setRefuseReason(reason: string) {
        this.refuseReason = reason;
    }

    async approveAudit(auditId: string) {
        const request: SignatureAuditRequest = {
            id: auditId,
            approved: true
        };

        this.loading = true;
        try {
            await signatureAuditApi.audit(request);
            await this.loadCandidates();
            await this.loadProcessed();
            this.setShowConfirmDialog(false);
        } finally {
            this.loading = false;
        }
    }

    async refuseAudit(auditId: string) {
        if (!this.refuseReason) return;

        const request: SignatureAuditRequest = {
            id: auditId,
            approved: false,
            refuseReason: this.refuseReason
        };

        this.loading = true;
        try {
            await signatureAuditApi.audit(request);
            await this.loadCandidates();
            await this.loadProcessed();
            this.setShowRefuseDialog(false);
        } finally {
            this.loading = false;
        }
    }
}

